import { AVAILABLE_YEARS, HIGHCHART_COLORS } from "../../../../libs/constant";

import React,{FC, useEffect, useState} from "react";
import Highcharts from 'highcharts/es-modules/masters/highcharts.src'
import "highcharts/es-modules/masters/highcharts-more.src"
import "highcharts/es-modules/masters/modules/exporting.src"
import "highcharts/es-modules/masters/modules/offline-exporting.src"
import "highcharts/es-modules/masters/modules/export-data.src"
import HighchartsReact from 'highcharts-react-official'
import { Dropdown, Card, Row, Spinner } from "react-bootstrap";
import TradePartnerDropdown from "./TradePartnerDropdown";
import useAxiosPrivate from "../../../../libs/useAxiosPrivate";
import { getHistoricalTradeData } from "../core/_request";
import { getNameByISO3, shortenLargeNumber } from "../../../../libs/misc";
import { useAuth } from "../../../../modules/auth";

interface ExtendedHighchartCreditInterface{
  credits:any
}

const CommodityLineChartCard:FC = () => {
  const { currentUser } = useAuth();
  const reporterISO3User = currentUser?.economy;
  const highchartOptions = {
    chart: {
      type: 'line',
      marginTop: 20,
      events: {
        load: function (this: ExtendedHighchartCreditInterface) {
          this.credits.element.onclick = function () {
            window.open('http://comtrade.un.org', '_blank');
          };
        }
      }
    },
    tooltip: {
      shared: true,
      crosshairs: true,
    },
    title: {
      text: ''
    },
    xAxis: [{
        crosshair: true,
        tickInterval: 1
      }],
    yAxis: [{
      labels: {
        formatter: function (this:any) { 
          return shortenLargeNumber(this.value); 
        },
      },
      title: {
        text: `Value in (USD)`,
      }
    }],
    plotOptions: {
      series:{
        connectNulls: true,
      }
    },
    credits: {
      enabled: true,
      text: 'Data source: UN Comtrade',
      href: '#',
      position: {
        align: 'center'
      }
    },
    exporting: {
      enabled: true
    },
    accessibility: {
      enabled: false
    }
  };

  const [historicalDataChartOptions, setHistoricalDataChartOptions] = useState<any>(highchartOptions)
  const [graphTitle, setGraphTitle] = useState<string>('')
  const axiosPrivate = useAxiosPrivate()

  const handleSelectPar = (econ:string)=>{
    getHistoricalTradeData(axiosPrivate, {
      rep:reporterISO3User,
      par:econ,
      tradeflow:'imports'
    })
    .then((res=>{
      const data = res.data.data
      const series = Object.entries(data.history_data).map((tradeflow:any)=>{
        let name = ''
        if(tradeflow[0]==='1'){
          name = `${getNameByISO3(tradeflow[1][0].rep)} imports from to ${getNameByISO3(tradeflow[1][0].par)}`
        }else{
          name = `${getNameByISO3(tradeflow[1][0].par)} exports to ${getNameByISO3(tradeflow[1][0].rep)}`
        }
        return {
          name: name,
          data: data.years_data.map((year)=>{
            return {
              x:year,
              y:tradeflow[1].find(trade=>trade.year===year)?.val||0
            }
          }),
          type: 'line',
          tooltip: { valueSuffix: ' US$' }
        }
      })
      setHistoricalDataChartOptions({
        ...historicalDataChartOptions,
        series,
      })
      setGraphTitle(`Trade Flows Over Time: Total Exports & Imports by Partner Economy`)
    }))
    .catch((err)=>{
      console.error(err)
    })
  }
  return (
    <>
      <Card className="card-custom">
        <Card.Header className="card-header-stretch d-flex align-items-center justify-content-between">
          <Card.Title>{graphTitle}</Card.Title>
          <TradePartnerDropdown onSelect={handleSelectPar}/>
        </Card.Header>
        <Card.Body style={{minHeight:'300px'}}>
          <HighchartsReact
            highcharts={Highcharts}
            options={historicalDataChartOptions}
          />
        </Card.Body>
      </Card>  
    </>
  )
}

export {CommodityLineChartCard}